import React from "react";
import Button from "../../common/Button/Button";

const SingleView = ({ data, onFinish }) => {
  return (
    <div className="flex flex-col h-full w-full px-6 xs:px-[30px] py-9 xs:py-[42px] items-center justify-between gap-4 xs:gap-6">
      <div className="flex flex-col gap-2 text-center items-center">
        <p className="text-[#253FF6] font-bold text-xs xs:text-sm">
          {data.subTitle}
        </p>
        <div className="flex items-center gap-2">
          <p className="text-xl xs:text-2xl font-bold text-[#253FF6]">
            {data.title}
          </p>
          {data.icon && (
            <span className="text-xl xs:text-2xl">{data.icon}</span>
          )}
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center w-full ">
        <img
          src={data.image}
          alt={data.title}
          className="h-[250px] xs:h-[300px] w-[299px] object-contain animate-fade-in-up transition-all duration-300"
        />
      </div>

      <div className="flex flex-col gap-4 xs:gap-6 w-full items-center">
        <p className="text-black text-sm xs:text-base text-center font-medium leading-relaxed whitespace-pre-line">
          {data.description}
        </p>
        <Button
          text={data.buttonText || "Got it"}
          onClick={onFinish}
          className="w-full py-3 rounded-md bg-[#253FF6] text-white font-bold"
        />
      </div>
    </div>
  );
};

export default SingleView;
